import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RegistrationResults } from '../../interfaces/registration-results/registration-results';
import { Order } from '../../interfaces/orders/order';

@Component({
    selector: 'lib-amendment-results',
    templateUrl: './amendment-results.component.html',
    styleUrls: ['./amendment-results.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AmendmentResultsComponent implements OnInit {
  @Input() order!: Order;
  @Input() result: RegistrationResults | undefined;

  protected changeText: string[] = [];

  ngOnInit(): void {
    if (this.result?.registryForm) {
      const actions = this.order.orderActions?.filter(a => a.registryForm?.id === this.result?.registryForm?.id);
      this.changeText = actions?.flatMap(a => a.changeText?.map(c => c.text) ?? []) ?? [];
    } else {
      this.changeText = this.order.orderActions?.flatMap(a => a.changeText?.map(c => c.text) ?? []) ?? [];
    }
  }
}
